import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TagService from "../../services/KangarooServices/TagService";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import DeleteModal from "../../Components/Common/DeleteModal";

const Tag = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
        const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const navigate = useNavigate();

  // Fetch all tags
  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await TagService.getList();
      setData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

    const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const toggleModal = (tag = null) => {
    setEditingTag(tag);
    setModalOpen(!modalOpen);
  };

  const handleDelete = async () => {
      if (selectedDeleteItem) {
        try {
          await TagService.delete(selectedDeleteItem.id);
          await fetchData();
          toast.success("Tag deleted successfully");
        } catch (error) {
          toast.error(
            error?.response?.data?.message || "Failed to delete Tag"
          );
        } finally {
          toggleDelete();
          setSelectedDeleteItem(null);
        }
      }
    };
  // const handleDeleteClick = async (id) => {
  //   try {
  //     await TagService.delete(id);
  //     fetchData();
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // const handleTagClick={
  //   navigate(`/tag/detail/${id}`);
  // }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editingTag ? editingTag.name : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Tag name is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        if (editingTag?.id) {
          await TagService.update(editingTag.id, values);
          toast.success("Tag Updated Successfully")
        } else {
          await TagService.create(values);
          toast.success("Tag Created Successfully")
        }
        fetchData();
        toggleModal(null);
        resetForm();
      } catch (error) {
        console.log(error);
      }
    },
  });

  const customStyles = {
    headCells: { style: { fontSize: "0.9rem", fontWeight: 600 } },
    rows: { style: { fontSize: "0.9rem" } },
  };

  const filteredData = data.filter((item) =>
    (item.name || "").toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: "S. N",
      cell: (row, index) => <div >{index + 1}</div>,
      width: "90px",
      center: true,
    },
   {
  name: "Name",
  cell: (row) => (
    <span
      style={{ cursor: "pointer", color: "#0d6efd", textDecoration: "none" }}
      onClick={() => navigate(`/tag/detail/${row.id}`)}
    >
      {row.name}
    </span>
  ),
  sortable: true,
}
,
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div>
          <Button
            size="sm"
            color="warning"
            className="btn-soft-warning me-2 p-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-pencil-line"></i>
          </Button>
          <Button
            size="sm"
            color="danger"
            className="btn-soft-danger p-1"
            onClick={() => handleDeleteClick(row)}
          >
            <i className="ri-delete-bin-5-line"></i>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Tags" pageTitle="Content management" />

        <Row className="g-4 mb-4 d-flex justify-content-between">

          <Col className="col-sm-auto">
            <Button color="success" onClick={() => toggleModal(null)}>
              <i className="ri-add-line align-bottom me-1"></i> Add Tag
            </Button>
          </Col>
          <Col md ={2} sm="4">
            <Input
              type="text"
              placeholder="Search by tag name..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </Col>

          
        </Row>

        {/* Desktop Table */}
        <Card className="d-none d-lg-block">
          <CardBody>
            <CustomDataTable
              columns={columns}
              data={filteredData}
              customStyles={customStyles}
              pagination
              striped
              responsive
              fixedHeader
              progressPending={loading}
            />
          </CardBody>
        </Card>

        {/* Mobile Cards */}
        {!loading &&
          filteredData.map((tag, index) => (
            <Card key={tag.id} className="d-block d-lg-none mb-3 shadow-sm">
              <CardBody>
                <h6 >
                  <strong>Name:</strong> {tag.name}
                </h6>
                <div>
                  <Button
                    size="sm"
                    color="warning"
                    className="btn-soft-warning me-2 p-1"
                    onClick={() => toggleModal(tag)}
                  >
                    <i className="ri-pencil-line"></i>
                  </Button>

                  <Button
                    size="sm"
                    color="danger"
                    className="btn-soft-danger p-1"
                    onClick={() => handleDeleteClick(tag)}
                  >
                    <i className="ri-delete-bin-5-line"></i>
                  </Button>
                </div>
              </CardBody>
            </Card>
          ))}

        {/* Modal for Add/Edit */}
        <Modal isOpen={modalOpen} toggle={() => toggleModal(null)}>
          <ModalHeader toggle={() => toggleModal(null)}>
            {editingTag ? "Update Tag" : "Add Tag"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={formik.handleSubmit}>
              <FormGroup>
                <Label for="tagName">Tag Name</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter tag name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.name && Boolean(formik.errors.name)}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-danger mt-1">{formik.errors.name}</div>
                )}
              </FormGroup>
              <ModalFooter>
                <Button color="primary" type="submit">
                  {editingTag ? "Update" : "Add"}
                </Button>
                <Button color="secondary" onClick={() => toggleModal(null)}>
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>

<DeleteModal
              show={isOpenDelete}
              onCloseClick={toggleDelete}
              onDeleteClick={handleDelete}
            />
      </div>
    </Container>
  );
};

export default Tag;
